import busService from './busService';
import store from '../store';
import { isArray } from 'lodash';
import translationsHelper from '@/utility/translationsHelper';

const handleTerminalTicket = (ticket, eventDetail) => {
  switch (ticket.status.id) {
    case '0': {
      handleAcceptedTicket(ticket);
      break;
    }
    case '1': {
      handleCanceledTicket(ticket, eventDetail);
      break;
    }
    case '5': {
      handlePaidOutTicket(ticket);
      break;
    }
    default:
  }
};

const handleAcceptedTicket = (ticket) => {
  ticket.bets.forEach((bet) => {
    // eslint-disable-next-line no-param-reassign
    if (bet.odd) bet.displayOdd = bet.odd; // Adjust to v1 template in production
  });
  const additionalData = {
    clientPrintJobIdentifier: {
      id: 'TicketPayIn',
      uuid: ticket.requestUuid,
    },
  };
  busService.sendMessage('Peripherals.Print', {
    type: 'ticket',
    productId: 'LuckyX',
    data: ticket,
    additionalData,
  });
  store.dispatch('showTerminalNotification', {
    message: store.getters.translations['ticket.add_success'],
    type: 'success',
    delay: 3000,
  });
};

const handleCanceledTicket = (ticket, eventDetail) => {
  busService.sendMessage('Tickets.Update', {
    action: 'Cancel',
    ticketData: ticket,
    showMessage: false,
  });
  const { isThirdPartyIntegration } = store.getters;
  if (isThirdPartyIntegration) {
    busService.sendMessage('Peripherals.Print', {
      layoutName: 'ticketCancel',
      productId: 'LuckyX',
      data: ticket,
    });
  }
  // Temp. code due to adding npm-packed translations and changing to more standard naming
  const key = store.state.usePackageTranslations ? 'ticket_cancel_success' : 'ticket.cancel_success_to_balance';
  store.dispatch('showTerminalNotification', {
    message: store.getters.translations[key].replace('{{amount}}', eventDetail.cancelledAmount.toFixed(2)),
    type: 'success',
    delay: 3000,
  });
  store.dispatch('setTicketDetailsData', ticket);
};

const handlePaidOutTicket = (ticket) => {
  const { userIsOperator, isThirdPartyIntegration } = store.getters;
  if (userIsOperator || isThirdPartyIntegration) {
    busService.sendMessage('Peripherals.Print', {
      layoutName: `ticketLuckyXPayout`,
      productId: 'LuckyX',
      data: ticket,
    });
  }
  // Temp. code due to adding npm-packed translations and changing to more standard naming
  const key = store.state.usePackageTranslations ? 'ticket_payout_success' : 'ticket.payout_success_to_balance';
  store.dispatch('showTerminalNotification', {
    message: store.getters.translations[key].replace('{{amount}}', ticket.payout.toFixed(2)),
    type: 'success',
    delay: 3000,
  });
  store.dispatch('setTicketDetailsData', ticket);
};

const handleTicketUpdateError = (payload) => {
  const { message } = payload;
  store.dispatch('showTerminalNotification', {
    message: message,
    type: 'warning',
    delay: 3000,
  });
};

const mapRebet = (ticket) => {
  const bets = [];
  ticket.bets.forEach((bet) => {
    bets.push({
      round: bet.eventId,
      market: translationsHelper.getBetName(bet, 'title'),
      outcome: isArray(bet.value) ? bet.value.join(' ') : translationsHelper.getOutcomeName(bet),
      outcomeIndex: isArray(bet.value) ? null : bet.outcome.value,
      stake: bet.amount,
      odds: bet.category === 'SPECIAL' ? bet.odd : null,
      type: bet.type,
      tax: bet.tax,
    });
  });
  return bets;
};

export default {
  handleTerminalTicket,
  handleTicketUpdateError,
  mapRebet,
};
